import React from "react";

export type TProductPlan = "Demo" | "Quick" | "Basic" | "Advanced";

interface IProductPlanMarkerProps {
	plan: TProductPlan;
	borderColor: string;
}

const ProductPlanMarker: React.FC<{ plan: TProductPlan }> = ({ plan }) => {
	const plans: IProductPlanMarkerProps[] = [
		{ plan: "Demo", borderColor: "border-sky-400" },
		{ plan: "Quick", borderColor: "border-sky-500" },
		{ plan: "Basic", borderColor: "border-sky-600" },
		{ plan: "Advanced", borderColor: "border-sky-700" },
	];

	const currentPlan = plans.find((p) => p.plan === plan) || plans[0]; // Default to first plan if not found

	return (
		<div
			className={`border-l-8 ${currentPlan.borderColor} bg-gray-200 p-1 px-4 drop-shadow-md`}
		>
			<span className="font-Poppins font-semibold text-md text-gray-800 tracking-wider">
				{currentPlan.plan}
			</span>
		</div>
	);
};

export default ProductPlanMarker;
